import { call, put, takeLatest } from 'redux-saga/effects';
import { Companies } from 'services/api';
import {
  adminCompanies,
  adminCompaniesSuccess,
  adminCompaniesFailure,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';

function* getAdminCompanies() {
  try {
    const { data } = yield call(Companies.adminCompanies);
    yield put(adminCompaniesSuccess(data));
  } catch (e) {
    yield put(adminCompaniesFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(adminCompanies, getAdminCompanies);
